// Marathi
export const mr = {
  'app.name':           'Kardolive',
  'app.tagline':        'ग्राहक पोर्टल',
  'app.signOut':        'साइन आउट',

  'login.email':        'ईमेल',
  'login.password':     'पासवर्ड',
  'login.signIn':       'साइन इन करा',
  'login.signingIn':    'साइन इन होत आहे…',
  'login.failed':       'साइन इन अयशस्वी',
  'login.newAccount':   'Kardolive वर नवीन?',
  'login.createAccount':'विनामूल्य खाते तयार करा →',

  'nav.workspace':      'कार्यक्षेत्र',
  'nav.templates':      'टेम्पलेट्स',
  'nav.live':           'लाइव्ह',
  'nav.rooms':          'रूम आणि चॅट',
  'nav.content':        'सामग्री',
  'nav.developer':      'विकासक',
  'nav.account':        'खाते',

  'nav.overview':       'विहंगावलोकन',
  'nav.projects':       'प्रकल्प',
  'nav.chat':           'चॅट कन्सोल',
  'nav.sessions':       'सत्रे',
  'nav.streams':        'थेट प्रवाह',
  'nav.studio':         'स्टुडिओ',
  'nav.recordings':     'रेकॉर्डिंग्ज',
  'nav.apiKeys':        'API की',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Webhook परीक्षक',
  'nav.networkTest':    'नेटवर्क चाचणी',
  'nav.embed':          'एम्बेड विजेट्स',
  'nav.sdk':            'SDK आणि दस्तऐवज',
  'nav.docs':           'Developer docs',
  'nav.analytics':      'विश्लेषण',
  'nav.settings':       'सेटिंग्ज',

  'overview.welcome':       'पुन्हा स्वागत, {name}',
  'overview.plan':          '{tenant} · {plan} योजना',
  'overview.newStream':     'नवीन प्रवाह',
  'overview.kpi.live':           'आता थेट',
  'overview.kpi.live.broadcasting': 'प्रवाह सुरू आहेत',
  'overview.kpi.live.nothing':    'कोणतेही थेट नाही',
  'overview.kpi.total':           'एकूण प्रवाह',
  'overview.kpi.total.sub':       'सर्व कालखंडात',
  'overview.kpi.sessions':        'सत्रे · 30 दिवस',
  'overview.kpi.sessions.sub':    'प्रकाशन घटना',
  'overview.kpi.recordings':      'रेकॉर्डिंग्ज',
  'overview.kpi.recordings.sub':  'खेळण्यासाठी तयार',
  'overview.recentStreams':       'अलीकडील प्रवाह',
  'overview.recentSessions':      'अलीकडील सत्रे',
  'overview.viewAll':             'सर्व पहा →',
  'overview.empty.title':         'अद्याप कोणतेही प्रवाह नाहीत',
  'overview.empty.body':          'प्रसारण सुरू करण्यासाठी आपला पहिला प्रवाह तयार करा.',
  'overview.empty.action':        'प्रवाह तयार करा',
  'overview.noSessions':          'अद्याप कोणतीही सत्रे नाहीत',

  'status.live':        'थेट',
  'status.idle':        'निष्क्रिय',
  'status.ended':       'समाप्त',
  'status.archived':    'संग्रहित',

  'common.save':        'जतन करा',
  'common.cancel':      'रद्द करा',
  'common.delete':      'हटवा',
  'common.edit':        'संपादित करा',
  'common.create':      'तयार करा',
  'common.confirm':     'पुष्टी करा',
  'common.loading':     'लोड होत आहे…',
  'common.error':       'त्रुटी',
  'common.retry':       'पुन्हा प्रयत्न करा',

  // Dashboard navigation and account controls.
  "nav.skipContent": "पृष्ठाच्या मजकुरावर जा",
  "nav.streamTemplates": "स्ट्रीम टेम्पलेट",
  "nav.boards": "परस्परसंवादी फलक",
  "nav.menu": "नेव्हिगेशन उघडा",
  "nav.closeMenu": "नेव्हिगेशन बंद करा",
  "nav.scenarios": "वापराच्या परिस्थिती",
  "nav.premieres": "प्रीमियर",
  "nav.clips": "क्लिप",
  "dashboard.account": "खाते",
  "dashboard.language": "भाषा",
  "dashboard.appearance": "स्वरूप",
  "nav.allStreams": "सर्व स्ट्रीम",
  "nav.destinations": "प्रसारणाची गंतव्ये",
  "nav.ecommerce": "ई-कॉमर्स",
  "nav.products": "उत्पादने",
  "nav.services": "सेवा",
  "nav.collections": "संग्रह",
  "nav.orders": "ऑर्डर",
  "nav.commerceSettings": "व्यापार सेटिंग्ज",
  "nav.engagement": "सहभाग",
  "theme.light": "फिकट मोडवर जा",
  "theme.dark": "गडद मोडवर जा",
  "role.owner": "मालक",
  "role.admin": "प्रशासक",
  "role.member": "सदस्य",
  "role.viewer": "प्रेक्षक",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "सक्रिय",
  "streams.archived": "संग्रहित",
  "streams.monitor": "स्रोत निरीक्षण",
  "streams.create": "लाइव्ह स्ट्रीम तयार करा",
  "streams.list": "यादी",
  "streams.grid": "ग्रिड",
  "streams.view": "स्ट्रीम दृश्य",
  "streams.searchLabel": "कार्यक्रम शोधा",
  "streams.searchHint": "कार्यक्रमाच्या नावाने शोधा",
  "streams.solutionFilter": "प्रकारानुसार कार्यक्रम गाळा",
  "streams.statusFilter": "स्थितीनुसार कार्यक्रम गाळा",
  "streams.dateFilter": "तयार केल्याच्या तारखेनुसार गाळा",
  "streams.allSolutions": "सर्व प्रकार",
  "streams.custom": "विद्यमान किंवा सानुकूल मांडणी",
  "streams.allStatuses": "सर्व स्थिती",
  "streams.anyTime": "कोणतीही निर्मिती तारीख",
  "streams.last7": "गेल्या ७ दिवसांत तयार केलेले",
  "streams.last30": "गेल्या ३० दिवसांत तयार केलेले",
  "streams.count": "{total} पैकी {shown} कार्यक्रम दाखवत आहोत",
  "streams.noMatch": "फिल्टरशी जुळणारा कार्यक्रम नाही.",
  "streams.clearFilters": "फिल्टर काढा",
  "streams.refreshFailed": "स्ट्रीमची यादी अद्ययावत करता आली नाही",
  "streams.loadFailed": "स्ट्रीम लोड करता आल्या नाहीत",
  "streams.stale": "शेवटची लोड केलेली यादी दाखवत आहोत. स्थिती बदलली असू शकते.",
  "streams.connectionHint": "कनेक्शन तपासून यादी पुन्हा लोड करा.",
  "streams.retrying": "पुन्हा प्रयत्न करत आहोत…",
  "streams.retry": "पुन्हा प्रयत्न करा",
  "streams.restoreFailed": "स्ट्रीम पुनर्संचयित करता आली नाही",
  "streams.restoreHint": "पुन्हा प्रयत्न करण्यापूर्वी कनेक्शन तपासा आणि सध्याच्या स्थितीसाठी यादी अद्ययावत करा.",
  "streams.unused": "न वापरलेल्या स्ट्रीम: {count}",
  "streams.unusedHint": "प्रसारण किंवा रिप्ले नाहीत. यादी आवरण्यासाठी संग्रहित करा; काहीही हटवले जाणार नाही.",
  "streams.reviewArchive": "तपासा आणि संग्रहित करा",
  "streams.loading": "स्ट्रीम लोड होत आहेत…",
  "streams.archiveEmpty": "संग्रह रिकामा आहे. संग्रहित स्ट्रीम व रिप्ले पुनर्संचयित करेपर्यंत येथे राहतात.",
  "streams.restore": "पुनर्संचयित करा",
  "streams.firstTitle": "पहिली स्ट्रीम तयार करा",
  "streams.firstBody": "विक्री, वर्ग किंवा सेवेसाठी मांडणी निवडा किंवा रिकाम्या स्ट्रीमपासून सुरुवात करा. ब्राउझर, फोन किंवा OBS मधून प्रसारण करा.",
  "streams.blank": "रिकामी स्ट्रीम",
  "streams.broadcasts": "प्रसारणे: {count}",
  "streams.replays": "रिप्ले: {count}",
  "streams.sessions": "सत्रे: {count}",
  "streams.recordings": "रेकॉर्डिंग: {count}",
  "streams.mode.BROADCAST": "प्रसारण",
  "streams.mode.LOW_LATENCY": "कमी विलंब",
  "streams.mode.REALTIME": "रिअल-टाइम",
  "streams.key": "की",
  "streams.archiveTitle": "न वापरलेल्या स्ट्रीम संग्रहित करा",
  "streams.archiveHint": "या स्ट्रीम कधीही प्रसारित झालेल्या नाहीत. संग्रहित टॅबमधून कधीही पुनर्संचयित करता येतील.",
  "streams.archiveFailed": "{count} स्ट्रीम संग्रहित करता आल्या नाहीत; त्या लाइव्ह झाल्या असू शकतात. बाकीच्या संग्रहित केल्या आहेत.",
  "streams.archiving": "संग्रहित करत आहोत…",
  "streams.archiveCount": "{count} संग्रहित करा",
  "streamType.webinar": "व्यावसायिक वेबिनार आणि लाँच",
  "streamType.classroom": "वर्ग आणि शिकवणी",
  "streamType.training": "कॉर्पोरेट प्रशिक्षण",
  "streamType.conference": "परिषदा आणि प्रदर्शने",
  "streamType.shopping": "लाइव्ह खरेदी",
  "streamType.auction": "लाइव्ह लिलाव",
  "streamType.consultation": "खाजगी सल्लामसलत",
  "streamType.creator": "निर्माते आणि समुदायाचे लाइव्ह",
  "streamType.audio": "ऑडिओ रूम आणि पॉडकास्ट",
  "streamType.sports": "खेळ आणि ई-स्पोर्ट्स",
  "streamType.performance": "संगीत कार्यक्रम आणि सादरीकरणे",
  "streamType.community": "उपासना आणि निधी संकलन",
  "streamType.tour": "भ्रमंती आणि प्रात्यक्षिके",
  "streamType.fitness": "फिटनेस आणि कार्यशाळा",
  "streamType.public-meeting": "बातम्या आणि सार्वजनिक बैठका",
  "streamType.continuous": "अखंड चॅनेल आणि कॅमेरे",
  "streams.close": "बंद करा",
};
